export default {
  emits: ['update:modelValue'],
  props: ['modelValue', 'disabled', 'unstyled', 'kind', 'attrs'],
}
